import Modal from 'react-modal';
import axios from 'axios';

const ShareCancellationModal = ({
  isOpen,
  closeModal,
  eventData,
}) => {
 const clientName = eventData?.clientName || 'Client';

 const handleCancelEvent = async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/cancelEvent/${eventData._id}`,
      {
        withCredentials: true,  
      }
    );

    closeModal();
  } catch (error) {
    console.error('Error cancelling event:', error);
  }
};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="modal-content"
      style={{
        content: {
          width: '570px',
          height: '600px',
          margin: 'auto',
          padding: '30px',
        },
      }}
    >
      <span className="close" onClick={closeModal}>&times;</span>

      <h2 style={{ fontWeight: 'bold', marginBottom: '20px' }}>
        Share Cancellation Request
      </h2>

      {/* Email To Box */}
      <div
        style={{
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '15px',
          border: '1px solid #D9D9D9',
           color: '#625C73',
        }}
      >
        <strong>EMAIL TO:</strong> {clientName}
      </div>

      {/* Subject Box */}
      <div
        style={{
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '15px',
          border: '1px solid #D9D9D9',
         color: '#625C73',
        }}
      >
        <strong>SUBJECT:</strong> Confirmation for Event Cancellation
      </div>

      {/* Message Text */}
      <div
        style={{
          padding: '15px',
          borderRadius: '5px',
          minHeight: '200px',
          border: '1px solid #D9D9D9',
        }}
      >
        <p style={{ fontSize: '14px', color: '#333' }}>
          Dear {clientName},<br /><br />
          We confirm that your event booking has been cancelled. A full refund of $
          {eventData?.expPaymentAmount} will be processed and should reflect in your account within
          15 business days.<br /><br />
          If you have any further questions or concerns, feel free to reach out to us.<br /><br />
          Best regards,<br />
          Event Team
        </p>
      </div>

      {/* Cancel Booking Button */}
      <div style={{ marginTop: '30px', textAlign: 'right' }}>
        <button
          onClick={handleCancelEvent}
          style={{
            background:
              'transparent linear-gradient(90deg, #1C1154 0%, #211074 47%, #260F99 100%)',
            border: '1px solid #43425D',
            borderRadius: '4px',
            color: '#FFFFFF',
            fontSize: '15px',
            cursor: 'pointer',
            width: '210px',
            height: '45px',
          }}
        >
          Send
        </button>
      </div>
    </Modal>
  );
};

export default ShareCancellationModal;
